import React from 'react';

import HomeContainer from './HomeContainer';
import { HomeDetail } from './HomeDetail';

const HomePage: React.FC = () => (
    <HomeContainer.Provider>
        <HomeDetail/>
    </HomeContainer.Provider>
);
export default HomePage;
